import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { Config } from '../../config/config';


@Injectable()
export class HttpService extends Config {

    constructor(private _http: Http, private _router: Router) {
        super()
    }

    httpGet(url) {

        var accessToken: string = sessionStorage.getItem('accessToken');

        var api = this.apiEndPoint() + url;

        var headers = new Headers({ 'Content-Type': 'application/json' });
        headers.append('x-access-token', accessToken);

        return this._http.get(api, { headers: headers })
            .map((response: Response) => {

                var res: any = response;
                var json = JSON.parse(res._body);

                // if (json.isValidToken) {
                console.log(json);
                return json;
                // } else {
                // this._router.navigate(['pages/login']);
                // }
            })
    }

    httpPost(url, data) {

        var api = this.apiEndPoint() + url;

        var accessToken: string = sessionStorage.getItem('accessToken');

        var headers = new Headers({ 'Content-Type': 'application/json' });
        // headers.append('x-access-token', accessToken);

        return this._http.post(api, JSON.stringify(data), { headers: headers })
            .map((response: Response) => {

                var res: any = response;
                var json = JSON.parse(res._body);


                console.log('API::' + api + '\n' +
                    'POST DATA::' + JSON.stringify(data) + '\n' +
                    'RESPONSE::' + JSON.stringify(json));


                return json;
            })
    }

}


// WEBPACK FOOTER //
// ./src/app/auth/_services/http.service.ts